module.exports = __webpack_public_path__ + "static/media/78694809.2f37e810.jpg";